<template>
  <div>
    <create-soil-type-card/>
    <soil-type-list/>
  </div>
</template>

<script>
import SoilTypeListTable from "../../components/soil-types/SoilTypeListTable";
import CreateSoilTypeCard from "../../components/soil-types/CreateSoilTypeCard";


export default {
  name: "SoilTypeList",
  components: {
    'soil-type-list': SoilTypeListTable,
    'create-soil-type-card': CreateSoilTypeCard
  }
}
</script>

<style scoped>

</style>